import React from 'react';
import { useSortableData } from '../../hooks/useSortableData';

const ProductTable = ({
  products,
  searchQuery,
  inStockCount,
  soldCount,
  formatAmount,
  onViewDetails,
  onEdit,
  onDelete,
  userRole,
  canEdit = false,
  canDelete = false,
}) => {
  const { sortedItems, sortKey, sortDir, requestSort } = useSortableData(products);
  const ind = (k) => (sortKey !== k ? '↕' : sortDir === 'asc' ? '▲' : '▼');

  if (products.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow overflow-hidden">
        <div className="p-8 text-center text-gray-500">
          {searchQuery ? 'No products found matching your search' : 'No products yet'}
        </div>
      </div>
    );
  }

  const SortHead = ({ k, align = 'left', children }) => (
    <th
      onClick={() => requestSort(k)}
      className={`px-4 py-3 text-${align} cursor-pointer select-none hover:bg-black/10`}
      data-testid={`sort-${k}`}
    >
      {children} <span className="text-[10px] opacity-80">{ind(k)}</span>
    </th>
  );

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <table className="w-full">
        <thead className="bg-gradient-to-r from-blue-700 to-green-700 text-white">
          <tr>
            <SortHead k="name">Product Name</SortHead>
            <SortHead k="category">Category</SortHead>
            <SortHead k="sub_category">Sub-Category</SortHead>
            <th className="px-4 py-3 text-center">In Stock</th>
            <th className="px-4 py-3 text-center">Sold</th>
            <SortHead k="price">Price</SortHead>
            <th className="px-4 py-3 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedItems.map((product, index) => (
            <tr key={product.id} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
              <td className="px-4 py-3 font-medium">{product.name}</td>
              <td className="px-4 py-3">
                <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">
                  {product.category || 'others'}
                </span>
              </td>
              <td className="px-4 py-3 text-sm">{product.sub_category || '-'}</td>
              <td className="px-4 py-3 text-center">
                <span className="font-bold text-green-600">{inStockCount(product)}</span>
              </td>
              <td className="px-4 py-3 text-center">
                <span className="font-bold text-gray-600">{soldCount(product)}</span>
              </td>
              <td className="px-4 py-3">{formatAmount(product.price || 0)}</td>
              <td className="px-4 py-3">
                <button
                  onClick={() => onViewDetails(product)}
                  className="text-blue-600 hover:text-blue-800 mr-3"
                >
                  👁️ View
                </button>
                {canEdit && (
                  <button
                    onClick={() => onEdit(product)}
                    className="text-green-600 hover:text-green-800 mr-3"
                  >
                    ✏️ Edit
                  </button>
                )}
                {canDelete && (
                  <button
                    onClick={() => onDelete(product)}
                    className="text-red-600 hover:text-red-800"
                    title="Admin: delete this product"
                  >
                    🗑 Delete
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;
